import { memo } from "react";
import { Template } from "./Template";
import type { KcProps } from "keycloakify";
import type { KcContextBase } from "keycloakify";
import { useKcMessage } from "keycloakify/lib/i18n/useKcMessage";

export const LoginPageExpired = memo(({ kcContext, ...props }: { kcContext: KcContextBase.LoginPageExpired } & KcProps) => {
    const { url } = kcContext;

    const { msg } = useKcMessage();

    return (
        <Template
            {...{ kcContext, ...props }}
            doFetchDefaultThemeResources={false}
            displayMessage={false}
            headerNode={msg("pageExpiredTitle")}
            headerDescription="Join a community of learners, researchers, and developers to build the next generation of quantum technology."
            formNode={
                <>
                    <p id="instruction1" className="instruction">
                        {msg("pageExpiredMsg1")}{" "}
                        <a id="loginRestartLink" href={url.loginRestartFlowUrl}>
                            {msg("doClickHere")}
                        </a>{" "}
                        .<br />
                        {msg("pageExpiredMsg2")}{" "}
                        <a id="loginContinueLink" href={url.loginAction}>
                            {msg("doClickHere")}
                        </a>{" "}
                        .
                    </p>
                </>
            }
        />
    );
});
